import React, { Component } from "react";
import FamilyService from "../services/family.service";

export default class AddExpense extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.saveExpense = this.saveExpense.bind(this);
    this.newExpense = this.newExpense.bind(this);
    this.handleToggleParticipants = this.handleToggleParticipants.bind(this);
    this.handleParticipantChange = this.handleParticipantChange.bind(this);

    const today = new Date().toISOString().split("T")[0];
    this.state = {
      id: null,
      name: "",
      date: today,
      type: "groceries",
      owner: "",
      tr: false,
      amount: "",
      location: "",
      note: "",
      submitted: false,
      selectedFamily: null,
      familyMembers: [],
      familyMembersWithCommon: [],
      amountInvalid: false,
      nameInvalid: false,
      locationInvalid: false,
      noteInvalid: false,
      participants: [],
      participantsExpanded: false
    };
  }

  handleToggleParticipants() {
    this.setState((prevState) => ({ participantsExpanded: !prevState.participantsExpanded }));
  }

  handleParticipantChange(e) {
    const { value, checked } = e.target;
    this.setState((prevState) => {
      let participants = [...prevState.participants];
      if (checked) {
        if (!participants.includes(value)) participants.push(value);
      } else {
        participants = participants.filter((p) => p !== value);
      }
      return { participants };
    });
  }

  componentDidMount() {
    const savedFamily = JSON.parse(localStorage.getItem("selectedFamily"));
    const selectedFamily = this.props.selectedFamily || savedFamily;
    this.setState({ selectedFamily: selectedFamily });
    // You can access the selected family via props
    console.log("Selected family in AddExpense:", this.props.selectedFamily || savedFamily);

    if (selectedFamily) {
      FamilyService.getFamilyMembers(selectedFamily.id)
        .then(response => {
          const allMembers = response.data;
          const filteredMembers = allMembers.filter(member => !member.username.endsWith('-common'));
          const allParticipants = filteredMembers.map(member => member._id || member.id);
          this.setState({
            familyMembers: filteredMembers,
            familyMembersWithCommon: allMembers,
            owner: allMembers.length > 0 ? allMembers[0].username : "",
            participants: allParticipants
          });
        })
        .catch(e => {
          console.log(e);
        });
    }
  }

  handleChange(e) {
    const { name, value, type, checked } = e.target;
    const isInvalid = /[<>$]/.test(value);

    if (name === "amount") {
      const hasLetters = /[a-zA-Z]/.test(value);
      const amountInvalid = value.includes(',') || isInvalid || hasLetters;
      this.setState({
        amount: value,
        amountInvalid: amountInvalid
      });
    } else if (name === "name" || name === "location" || name === "note") {
        this.setState({
            [name]: value,
            [name + "Invalid"]: isInvalid
        });
    }
    else {
      this.setState({
        [name]: type === "checkbox" ? checked : value
      });
    }
  }

  saveExpense(e) {
    e.preventDefault();

    if (this.state.amountInvalid || this.state.nameInvalid || this.state.locationInvalid || this.state.noteInvalid) {
      console.error("Invalid input. Please remove special characters like <, >, $");
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || !user.id) {
      console.error("User ID not found in local storage.");
      return;
    }

    if (!this.state.selectedFamily || !this.state.selectedFamily.name) {
      console.error("Family not selected.");
      // Optionally, show an error message to the user
      return;
    }

    const expenseData = {
      name: this.state.name,
      date: this.state.date,
      type: this.state.type,
      owner: this.state.owner,
      tr: this.state.tr,
      amount: this.state.amount,
      location: this.state.location,
      note: this.state.note,
      publisher: user.id,
      participants: this.state.participants,
    };

    FamilyService.addExpenseToFamily(this.state.selectedFamily.id, expenseData)
      .then(response => {
        this.setState({
          submitted: true
        });
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }

  newExpense() {
    const today = new Date().toISOString().split("T")[0];
    const allParticipants = this.state.familyMembers.map(member => member._id || member.id);
    this.setState({
      id: null,
      name: "",
      date: today,
      type: "groceries",
      owner: this.state.familyMembersWithCommon.length > 0 ? this.state.familyMembersWithCommon[0].username : "",
      tr: false,
      amount: "",
      location: "",
      note: "",
      submitted: false,
      participants: allParticipants,
      participantsExpanded: false
    });
  }

  render() {
    const { selectedFamily } = this.state;
    return (
      <div className="submit-form">
        {this.state.submitted ? (
          <div>
            <h4>You submitted successfully!</h4>
            <button className="btn btn-success" onClick={this.newExpense}>
              Add
            </button>
          </div>
        ) : (
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Add Expense</h5>
          {selectedFamily && <p className="card-text">Adding expense for: <strong>{selectedFamily.name}</strong></p>}
          <form onSubmit={this.saveExpense}>
            <div className="form-group mb-2">
              <label>Expense *</label>
              <input type="text" className={`form-control ${this.state.nameInvalid ? 'is-invalid' : ''}`} name="name" value={this.state.name} onChange={this.handleChange} />
            </div>
            <div className="form-group mb-2">
              <label>Date *</label>
              <input type="date" className="form-control" name="date" value={this.state.date} onChange={this.handleChange} />
            </div>
            <div className="form-group mb-2">
              <label>Type *</label>
              <select className="form-control" name="type" value={this.state.type} onChange={this.handleChange}>
                <option>basic</option>
                <option>groceries</option>
                <option>transport</option>
                <option>eatout</option>
                <option>travel</option>
                <option>other</option>
              </select>
            </div>
            <div className="form-group mb-2">
              <label>Owner *</label>
              <select className="form-control" name="owner" value={this.state.owner} onChange={this.handleChange}>
                {this.state.familyMembersWithCommon && this.state.familyMembersWithCommon.map((member, index) => (
                  <option key={index} value={member.username}>{member.username}</option>
                ))}
              </select>
            </div>
            {/* Participants expandable checkbox list */}
            <div className="form-group mb-2">
              <label style={{ display: 'block', cursor: 'pointer' }} onClick={this.handleToggleParticipants}>
                Participants <span style={{ fontWeight: 'bold' }}>{this.state.participantsExpanded ? '▲' : '▼'}</span>
              </label>
              {this.state.participantsExpanded && (
                <div style={{ border: '1px solid #ccc', borderRadius: 4, padding: 8, marginTop: 4, maxHeight: 150, overflowY: 'auto' }}>
                  {this.state.familyMembers && this.state.familyMembers.length > 0 ? (
                    this.state.familyMembers.map((member, idx) => {
                      const memberId = member._id || member.id;
                      return (
                        <div key={member.username || idx} className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`participant-${member.username}`}
                            value={memberId}
                            checked={this.state.participants.includes(memberId)}
                            onChange={this.handleParticipantChange}
                          />
                          <label className="form-check-label" htmlFor={`participant-${member.username}`}>{member.username}</label>
                        </div>
                      );
                    })
                  ) : (
                    <div>No users found.</div>
                  )}
                </div>
              )}
            </div>
            {/* Existing Tr checkbox */}
            <div className="form-group form-check mb-2">
              <input type="checkbox" className="form-check-input" name="tr" checked={this.state.tr} onChange={this.handleChange} id="trCheck" />
              <label className="form-check-label" htmlFor="trCheck">Tr</label>
            </div>
            <div className="form-group mb-2">
              <label>Amount *</label>
              <input type="text" inputMode="decimal" pattern="[0-9]*[.]?[0-9]*" className={`form-control ${this.state.amountInvalid ? 'is-invalid' : ''}`} name="amount" value={this.state.amount} onChange={this.handleChange} />
            </div>
            <div className="form-group mb-2">
              <label>Location</label>
              <input type="text" className={`form-control ${this.state.locationInvalid ? 'is-invalid' : ''}`} name="location" value={this.state.location} onChange={this.handleChange} />
            </div>
            <div className="form-group mb-2">
              <label>Note</label>
              <input type="text" className={`form-control ${this.state.noteInvalid ? 'is-invalid' : ''}`} name="note" value={this.state.note} onChange={this.handleChange} />
            </div>
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-block" disabled={
                !this.state.name || 
                !this.state.date || 
                !this.state.type || 
                !this.state.owner || 
                !this.state.amount || 
                this.state.amountInvalid || 
                this.state.nameInvalid || 
                this.state.locationInvalid || 
                this.state.noteInvalid
              }>Add</button>
            </div>
          </form>
        </div>
      </div>
        )}
      </div>
    );
  }
}
